"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LAZY_IMAGE_PLACEHOLDER = exports.LAZY_IMAGE = void 0;
const LAZY_IMAGE = exports.LAZY_IMAGE = 'LazyImage';
const LAZY_IMAGE_PLACEHOLDER = exports.LAZY_IMAGE_PLACEHOLDER = 'LazyImagePlaceholder';
//# sourceMappingURL=lazyImage.js.map